import config from '@/config';
import { ErrorType } from '@/utilities/errors/types';
import { CustomError } from '@/utilities/errors/CustomError';
import { createApiAxios } from '@/utilities/axios/api-axios';
import { HEADERS } from '@/utilities/constants/metadata';
import { useStore } from '@/store/useStore';
import { getGameWindowDataScope } from '@/api/game-window-data/get-scope';
import {
  GameWindowDataParams,
  GameWindowDataResponse,
} from '@/api/game-window-data/types';

export const fetchGameWindowData = async ({
  gameUid,
  rgsDesktop,
}: GameWindowDataParams): Promise<GameWindowDataResponse> => {
  const { baseUrl: baseUrlOverride, endpoints } = config?.gameWindowData ?? {};
  const endpoint = endpoints?.gameWindow;
  const runtimeBaseUrl = useStore.getState().runtime.baseURL;
  const { region, product, platform } = getGameWindowDataScope();

  const baseURL = baseUrlOverride ?? runtimeBaseUrl;

  if (!baseURL || !endpoint) {
    throw new CustomError(
      '[GW][GAME_WINDOW_DATA]: Missing service configuration',
      {
        type: ErrorType.API,
        reason:
          'gameWindowData.baseUrl / runtime.baseURL or gameWindowData.endpoints.gameWindow is not configured',
      },
    );
  }

  try {
    const instance = createApiAxios();
    const response = await instance.get<GameWindowDataResponse>(endpoint, {
      baseURL,
      params: {
        region,
        product,
        platform,
        ...(gameUid && { gameUid }),
        ...(rgsDesktop && { rgsDesktop }),
      },
      headers: {
        [HEADERS.CACHE_CONTROL]: false,
      },
    });

    if (!response) {
      throw new Error('[GW][GAME_WINDOW_DATA]: No response received');
    }

    return response.data;
  } catch (error) {
    throw new CustomError((error as CustomError).message, {
      type: ErrorType.API,
      reason: 'Failed to fetch game-window-data',
    });
  }
};

export default fetchGameWindowData;
